import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import { Alert } from '@artprov/design-system'
import { useDdjjMedicoStore } from '@/common/zustand/store/ddjj-medico.store'

/**
 * PBI 81147 (D6): toast global de la carga de la DDJJ. Se monta en el layout
 * protegido porque el modal se desmonta al cerrarse y el aviso debe sobrevivirle.
 * Mismo formato que ToastSeleccionCuenta: portal, Alert y autocierre a los 4 s.
 * Muestra el aviso de éxito (variante success) o el de error genérico de carga
 * (variante error, PBI 81147: el error se ve por fuera del modal).
 */
export default function AvisoCargaDdjj({ duracionMs = 4000 }) {
  const avisoExito = useDdjjMedicoStore((state) => state.avisoExito)
  const avisoError = useDdjjMedicoStore((state) => state.avisoError)
  const cerrarAviso = useDdjjMedicoStore((state) => state.cerrarAviso)
  const cerrarAvisoError = useDdjjMedicoStore((state) => state.cerrarAvisoError)
  const aviso = avisoError ?? avisoExito
  const variante = avisoError ? 'error' : 'success'

  useEffect(() => {
    if (!aviso) return undefined
    const cerrar = avisoError ? cerrarAvisoError : cerrarAviso
    const timer = setTimeout(cerrar, duracionMs)
    return () => clearTimeout(timer)
  }, [aviso, avisoError, cerrarAviso, cerrarAvisoError, duracionMs])

  if (!aviso) return null

  const cerrar = avisoError ? cerrarAvisoError : cerrarAviso

  return createPortal(
    <div className="fixed top-4 right-4 w-[400px]" style={{ zIndex: 99999 }}>
      <Alert
        variant={variante}
        iconStyle="default"
        title=""
        description={aviso}
        descriptionStyle="whitespace-normal break-normal"
        interactive={true}
        buttonText=""
        onClose={cerrar}
        containerStyle="!max-w-none w-full"
      />
    </div>,
    document.body
  )
}

AvisoCargaDdjj.propTypes = {
  duracionMs: PropTypes.number,
}
